import { TableId } from "@greeter/core";
import { upsert } from "@greeter/map";

/**
 * Human readable format for table ids.
 */
export function summarizeTables(tables: Array<TableId>) {
  const s: Array<string> = [];
  const areas: Map<string, Array<TableId>> = new Map();

  for (let i = 0, l = tables.length; i < l; i++) {
    const tableId = tables[i];
    upsert(areas, tableId.area, tableId);
  }

  const areaLength = Array.from(areas).length;
  let j = 0;
  for (let [k, v] of areas.entries()) {
    for (let i = 0, l = v.length; i < l; i++) {
      const isLast = i === v.length - 1;
      const isFirst = i === 0;
      // const isSecondLast = v.length - 2 === j;

      if (s.at(-1) !== " " && !isFirst) {
        s.push(" ");
      }

      const tableId = v[i];
      s.push(`${tableId.tableNumber}`);
      if (!isLast) {
        s.push(",");
      }
    }

    s.push(` i ${k}`);
    const isLast = areaLength - 1 === j;
    const isSecondLast = areaLength - 2 === j;

    if (!isLast && !isSecondLast) {
      s.push(", ");
    }

    if (isSecondLast) {
      s.push(" og ");
    }

    j++;
  }

  return s.join("");
}

